import {isMobile} from "../../../domain/common";

window.addEventListener('DOMContentLoaded', (event) => {
    if(!isMobile())
        return;
    const elSlider = document.querySelectorAll("[data-carusel]");
    let ind = 1;
    elSlider.forEach(function(el:any) {
        //console.log('elSlider el: ',el);
        //console.log(`Carusel index2: `,isMobile());
        const dataCarusel = el.getAttribute("data-carusel");
        if(dataCarusel === "mobile") {
            //console.log('elSlider mobile el: ',el);
            const caruselID = "data-carusel-" + ind++;
            el.parentElement.setAttribute("data-carusel-mode", "mobile");
            el.setAttribute("id", caruselID);

            let startPosition:any = 0;
            const ul = el.querySelectorAll('ul li');
            for (let i = 0; i <= ul.length - 1; i++) {
                //console.log(ul[i].firstChild);
                if(ul[i].firstChild.classList.contains('bg-blue-200')){
                    //console.log(ul[i]);
                    startPosition = ul[i].getBoundingClientRect();
                }
                else{
                    startPosition = {left:20, right:0};
                }
            }
            //console.log(`startPosition: ${0 - startPosition.right}`,startPosition);
            //el.bg-blue-200

            el.style.transform  = `translateX(${(0 - startPosition.left + 20)}px)`;

            //const leftStr = el.style.left.replace("px", "");
            //const left = parseInt(leftStr);
            checkArrows(el, 0);

            //el.nextSibling.style.display = 'flex';//show right arrow
            el.addEventListener('touchstart', handleTouchStart, false);
            el.addEventListener('touchmove', handleTouchMove, false);
            if(el.nextSibling)
                el.nextSibling.addEventListener('click',  function () {arrowClick (caruselID, 'right')}, false);
            if(el.previousSibling)
                el.previousSibling.addEventListener('click',  function () {arrowClick (caruselID, 'left')}, false);

        }

    });


    var xDown:any = null;
    var yDown:any = null;

    function getTouches(evt:any) {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt:any) {
        console.log('handleTouchStart: ');
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    };

    function handleTouchMove(evt:any) {
        console.log('handleTouchMove: ');
        if ( ! xDown || ! yDown ) {
            return;
        }
        const speed = 5;
        let carouselElement: any = evt.target.parentElement.parentElement;
        if(!carouselElement.hasAttribute("data-carusel"))
        {
            carouselElement = evt.target.parentElement;
        }
        //const leftStr = carouselElement.style.left.replace("px", "");
        //const left = parseInt(leftStr);
        const transformPosStr =carouselElement.style.transform.replace(")px", "").replace("px)", "").replace("translateX(", "");
        const transformPos = parseInt(transformPosStr);
        //console.log('transformPos: ',transformPos,carouselElement);
        //if(transformPos == NaN)
        //    console.log('transformPosStr: ',transformPosStr);
        checkArrows(carouselElement, transformPos);
        //const carouselLimitWidth = (carouselElement.offsetWidth - window.screen.width);

        const xUp = evt.touches[0].clientX;
        const yUp = evt.touches[0].clientY;

        const xDiff = xDown - xUp;
        const yDiff = yDown - yUp;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
            if ( xDiff > 0 ) {
                /* left swipe */
                if(Math.abs(transformPos) >= (carouselElement.offsetWidth - window.screen.width) ) {
                    return;
                }
                const calcPos = transformPos - 10*(speed/5);
                carouselElement.style.transform  = `translateX(${calcPos}px)`;

            } else {
                /* right swipe */
                if(transformPos >= 0) {
                    return;
                }
                //carouselElement.style.left = (left + 10*(speed/5)) + 'px';
                const calcPos = transformPos + 10*(speed/5);
                carouselElement.style.transform  = `translateX(${calcPos}px)`;
            }
        } else {
            if ( yDiff > 0 ) {
                /* down swipe */
            } else {
                /* up swipe */
            }
        }
        /* reset values */
        //xDown = null;
        //yDown = null;
        xDown = evt.touches[0].clientX;
        yDown = evt.touches[0].clientY;
    };
    function checkArrows(carouselElement: any, left:number){
        if(isNaN(left) ){
            //console.log(`1.left: ${left}, caruselLimit:${carouselElement.offsetWidth - window.screen.width}`);
            return;
        }
        const arrowLeft_Arr:any = carouselElement.parentElement.getElementsByClassName("arr-left");
        const arrowRight_Arr:any = carouselElement.parentElement.getElementsByClassName("arr-right");
        const arrowLeft:any = arrowLeft_Arr.length > 0 ? arrowLeft_Arr[0] : null;
        const arrowRight:any =arrowRight_Arr.length > 0 ? arrowRight_Arr[0] : null;

        //console.log(`2.left: ${left}, caruselLimit:${carouselElement.offsetWidth - window.screen.width}`);

        if(arrowLeft && arrowRight)
        {
            if(left >= 0)
                arrowLeft.style.display = 'none';
            //else
            //left row is hide
            //arrowLeft.style.display = 'flex';

            if(Math.abs(left) >= (carouselElement.offsetWidth - window.screen.width - 20) )
                arrowRight.style.display = 'none';
            else
                arrowRight.style.display = 'flex';
        }
    }

    function arrowClick(caruselID:string, dir:string){
        const carouselElement: any = document.getElementById(caruselID);
        const caruselLimit = carouselElement.offsetWidth - window.screen.width;

        //const leftStr = carouselElement.style.left.replace("px", "");
        //const left = parseInt(leftStr);

        const transformPosStr =carouselElement.style.transform.replace(")px", "").replace("px)", "").replace("translateX(", "");
        const transformPos = parseInt(transformPosStr);

        let moveStep =0;
        //console.log(`left: ${transformPos}, caruselLimit:${caruselLimit}`);

        if(transformPos > 0)
            return;

        if(Math.abs(transformPos) >= caruselLimit )
            return;
        if(dir === 'transformPos'){
            moveStep= transformPos + 200 < 0 ? 200 : -transformPos;
            //carouselElement.style.left = (left + moveStep) + 'px';
            carouselElement.style.transform  = `translateX(${(transformPos + moveStep)}px)`;

            checkArrows(carouselElement, (transformPos + moveStep));
        }
        if(dir === 'right'){
            moveStep= caruselLimit + transformPos > 200 ? 200 : caruselLimit + transformPos;

            //carouselElement.style.left = (transformPos - moveStep) + 'px';
            carouselElement.style.transform  = `translateX(${(transformPos - moveStep)}px)`;

            checkArrows(carouselElement, (transformPos - moveStep));
        }

    }
});




export {};